import React, { useState, useEffect } from "react";
import style from "./footerPage.module.css";
import { BASE_URL } from "../../../constants/Constants";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import { useNavigate } from "react-router-dom";
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import { _axios } from "../../../utils/axios";

const FooterPage = () => {
  const [footerText, setFooterText] = useState("");
  const [isFooterActive, setIsFooterActive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Fetch data from the backend when the component mounts
    fetchData();
  }, []);

  const fetchData = () => {
    _axios.post(`${BASE_URL}/api/footer/footer`)
      .then((response) => {
        if (response?.data?.success === 0) {
          ErrorToast(response?.data?.message)
          return
        }
        const data = response.data.data[0];
        setFooterText(data.footer_text || "");
        console.log(response);
        // setIsFooterActive(data.isFooterActive || false);
      })
      .catch((error) => {
        if (error?.response?.data?.message) {
          ErrorToast(error?.response?.data?.message)
        }
        console.log('error', error);
      });
  };

  const updateData = async () => {
    try {

      // Check if the length of footerText exceeds the limit
      if (footerText.length > 150) {
        ErrorToast("Footer text should not exceed 150 characters");
        return;
      }

      const response = await _axios.patch(
        `${BASE_URL}/api/footer/`,
        {
          footer_id: "1",
          footer_text: footerText,
          // isFooterActive: isFooterActive,
        }
      );
      if (response?.data?.success === 0) {
        ErrorToast(response?.data?.message)
        return
      }
      // if (response?.data?.message) {
      //   ErrorToast(response?.data?.message)
      // }
      SuccessToast('Footer Updated')
      setTimeout(() => {
        window.location.reload();
      }, 2000);

      console.log(response.data); // Log the response from the backend
    } catch (error) {
      console.error("Error updating data:", error);
    }
  };


  return (
    <div>
      <div className={style.bodyBox}>
        {/* Main content here */}

        <div className={style.bodyHeading}>
          <p className={style.bodyTitle}>Footer Text Upload</p>
        </div>

        <BoxComponent>
          <div className={style.logoUploadContainer}>
            <div className={style.tickerForm}>
              <label htmlFor="tickerText" className={style.smallLable}>
                Footer Text
              </label>
              <textarea
                id="tickerText"
                className={style.footerTextarea}
                placeholder="Powered by Stralto Global Pvt ltd. All rights reserved"
                value={footerText}
                onChange={(e) => setFooterText(e.target.value)}
              ></textarea>

              <div>
                <br />

                {/* <div className={style.footerActive}>
                <label className={style.footerActive}>Footer Activate</label>
                <label className={style.toggleBtn}>
                  <input
                    type="checkbox"
                    className={style.inputCheckbox}
                    checked={isFooterActive} // Set the checked attribute based on the state
                    onChange={() => setIsFooterActive((prev) => !prev)} // Toggle the state on checkbox change
                  />
                  <span className={style.slider}></span>
                </label>
              </div> */}
              </div>

              <div className={style.buttonSection}>
                <button className="bg-primary ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300" onClick={updateData}>Publish</button>

                <button className="bg-black ml-4 px-6 py-2 font-bold text-white rounded-full disabled:bg-gray-300" onClick={() => navigate('/dashboard')}>Close</button>
              </div>
            </div>
          </div>
        </BoxComponent>
        <br />

      </div>

      {/* <p className={style.footerBottom}>{footerText}</p> */}
    </div>
  );
};

export default FooterPage;
